// Firebase client configuration for auth, Firestore, storage, and analytics.
// Env vars (frontend web config, non-secret):
// - REACT_APP_FIREBASE_API_KEY
// - REACT_APP_FIREBASE_AUTH_DOMAIN
// - REACT_APP_FIREBASE_PROJECT_ID
// - REACT_APP_FIREBASE_STORAGE_BUCKET
// - REACT_APP_FIREBASE_MESSAGING_SENDER_ID
// - REACT_APP_FIREBASE_APP_ID
// - REACT_APP_FIREBASE_MEASUREMENT_ID (optional, for Analytics)

import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Guard against missing config in local dev – avoids runtime crash
if (!firebaseConfig.apiKey) {
  // eslint-disable-next-line no-console
  console.warn('Firebase API key is missing. Check your REACT_APP_FIREBASE_* env vars.');
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analytics is optional and only works in the browser.
let analyticsInstance = null;

if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (supported) {
        analyticsInstance = getAnalytics(app);
      }
    })
    .catch(() => {
      // ignore analytics errors in unsupported environments
    });
}

export const analytics = analyticsInstance;


